export default {
	Banner: {
		Title: {
			Line1: 'NÂNG CẤP LÊN',
			Line2: 'PHIÊN BẢN MỚI'
		},
		Description:
			'Để trải nghiệm của bạn trở nên tuyệt vời nhất. Tích hợp vào nền tảng MISA AMIS ngay hôm nay!',
		Feature1: {
			Title: '1. Giao diện hiện đại',
			Desc: 'Giao diện hiện đại, tiện ích và dễ sử dụng hơn'
		},
		Feature2: {
			Title: '2. Hệ sinh thái kết nối',
			Desc:
				'Kết nối liền mạch với các sản phẩm trong hệ sinh thái MISA AMIS như: Kế toán, Agent, chat,...'
		},
		Feature3: {
			Title: '3. QUÀ TẶNG',
			Desc: 'Trải nghiệm 6 ứng dụng miễn phí trong nền tảng MISA AMIS'
		},
		Button: 'NÂNG CẤP MIỄN PHÍ NGAY',
		HeaderAppName: 'AMIS Thuế điện tử'
	},
	Processing: {
		Title: 'Đang tiến hành nâng cấp sang phiên bản mới',
		Description:
			'Trong thời gian tích hợp, bạn vẫn có thể thao tác trên phần mềm. Chương trình sẽ thông báo sau khi quá trình cập nhật hoàn tất.',
		Button: 'Đóng'
	},
	Success: {
		Title: {
			Line1: 'Nâng cấp thành công!',
			Line2: 'Vui lòng đăng nhập lại với thông tin'
		},
		Instruction: {
			Username: 'Tên đăng nhập: Số điện thoại hoặc email đã đăng ký',
			Password: 'Mật khẩu: Mật khẩu đã đăng ký'
		},
		Button: {
			Later: 'Để sau',
			Relogin: 'ĐĂNG NHẬP LẠI'
		}
	},
	Bell: {
		Title: 'Nâng cấp thành công. Đăng xuất, đăng nhập để trải nghiệm ngay.',
		ViewDetail: 'Xem chi tiết'
	},
	Company: {
		Title: 'Chọn dữ liệu công ty',
		Description: 'Vui lòng chọn chính xác dữ liệu công ty muốn tích hợp',
		Button: 'Tiếp tục',
		Cancel: 'Hủy',
		LoadError: 'Tải danh sách công ty thất bại',
		ActivateError: 'Nâng cấp sang AMIS thất bại',
		ValidateError: 'Công ty tích hợp',
		ColTax: 'Mã số thuế',
		ColTenantName: 'Tên đơn vị',
		ColAdmin: 'Quản trị',
		ColCreatedDate: 'Ngày tạo',
		ColAppNames: 'Ứng dụng đang sử dụng'
	}
};
